<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Licensing</p>
          <div class="float-right">
            <Filters />
          </div>
        </div>
        <Table />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '../components/youtube/licensing/Filters'
import Table from '../components/youtube/licensing/Table'
import { mapState } from 'vuex'

export default {
  components: {
    Filters,
    Table
  },

  computed: {
    ...mapState('youtubeLicensing', ['loading'])
  }
}
</script>
